/**
 * 
 * @param {Number} index 
 * @param {HTML} element 
 */

 function ProductGrid( index, element ) {
    this.$element = $( element );
    this.$index = index;

    this.selectors = {
        items: ".product-grid__items",
        item: ".product-grid__item",
        filters: ".product-grid__filters-inner",
        filter: ".product-grid__filter"
    }

    this.gutter;

    this.init();
}

ProductGrid.prototype = Object.assign( {}, ProductGrid.prototype, {
    init: function() {
        this.$items = this.$element.find( this.selectors.items );
        this.$item = this.$element.find( this.selectors.item );
        this.$filter = this.$element.find( this.selectors.filter );
        this.gutter = this.$items.data( "gutter" );

        this.$filter.on( "click", this.__handleFilterClick.bind( this ) );
        $( window ).on( "load resize", this.__handleMatchItemsHeight.bind( this ) );
    },
    __handleFilterClick: function( event ) {
        if( $( event.currentTarget ).hasClass( "is-active" ) ) return;
        this.disableActiveClass();
        this.hideAllItems();
        $( event.currentTarget ).addClass( "is-active" );
        this.showItem( $( $( event.currentTarget ).data( "filter" ) ) );
    },
    __handleMatchItemsHeight: function() {
        this.$item.css( "height", "auto" ); //to reset the height before recalculation

        if( $( window ).width() <= 639 ) return; //to only apply the calculation on medium sized screens and above
        
        var heights = this.$item.map(function ()
        {
            return $(this).height();
        }).get();
        maxHeight = Math.max.apply(null, heights);
        this.$item.height( maxHeight );
    },  
    disableActiveClass: function() {
        this.$filter.removeClass( "is-active" );
    },
    hideAllItems: function() {
        this.$item.fadeOut();
    },
    showItem: function( item ) {
        setTimeout( function(){
            item.fadeIn();
            $('html, body').animate({
                scrollTop: $("#grid-scroll-anchor").offset().top - 96
            }, 300);
        }, 300 );
    }
} );

